<template>
    <div>
        <BaseCalendar
            v-slot="{event, backgroundColor}"
            class="calendar-component"
            :class="{'events-loading': loading}"
            :event-sources="appointmentsAsEventSource"
            :loading="loading"
            :i-frame-type="iFrameType">
            <CalendarEventContent
                :event="event"
                :background-color="backgroundColor"
                :force-tooltip-close="showingSingleEvent"
                @open="$emit('update:showEvent', $event)" />
        </BaseCalendar>
    </div>
</template>

<script>
import lazyLoadedComponentsMixin from '@/mixins/lazyLoadedComponentsMixin'

export default {
    name: "IFrameEventCalendar",
    mixins: [lazyLoadedComponentsMixin],
    props: {
        events: {
            type: Array,
            required: true
        },
        iFrameType: {
            type: String,
            required: true
        },
        colorScheme: {
            type: Object,
            required: true
        },
        showNumberOfLoadingEntries: {
            type: Number,
            default: 0
        },
        showingSingleEvent: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        appointmentsAsEventSource() {
            if (!this.events) return []
            return [
                {
                    events: this.events.filter(event => !!(event.startDate && event.endDate)).map(event => {
                        const allDay = this.$moment(event.startDate)
                            .isSame(this.$moment(event.startDate).startOf('day'), 'minute')
                            && this.$moment(event.endDate)
                                .isSame(this.$moment(event.endDate).startOf('day'), 'minute')
                        return {
                            ...event,
                            title: event.name,
                            start: event.startDate,
                            end: (allDay && event.endDate) ? this.$moment(event.endDate).add(1, 'day').toDate() : event.endDate,
                            openEnd: event.openEnd,
                            all_day: allDay,
                            allDay
                        }
                    }),
                    color: this.colorScheme.primary
                }
            ]
        }
    },
    mounted() {
        this.$emit('hook:mounted')
    }
}
</script>

<style lang="scss" scoped>
.calendar-component {
    position: relative;

    &::before {
        content: "";
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        font-size: x-large;
        font-weight: bold;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        pointer-events: none;
        background-color: transparent;
        z-index: 10;
        color: transparent;
        transition: all $map-transition-duration $map-timing-function;
    }

    &.events-loading {
        pointer-events: none;

        &::before {
            content: "Suche...";
            color: $white;
            background-color: rgba($gray-200, 0.5);
        }
    }
}
</style>
